<template>
  <div class="p-6">
   <h1> Top 10 recently published books</h1>
    <v-row>   
     <v-data-table
        :headers="headers"
        :items="books"
        :search="search"
        item-key="name"
        class="elevation-1"
        @current-items="getFiltered"
        :hide-default-footer="true"
      >
      </v-data-table>
    </v-row>
  </div>
</template>

<script>
import * as API from "./../api";

export default {
  name: "Dashboard",
  methods: {
    getBooks() {
      this.$api
        .get(API.endpoints.books)
        .then((response) => {
          this.books = response.data;
          console.log(this.books)<
          this.books.sort(function(a, b) {
            var dateA = new Date(a.PublishDate),
              dateB = new Date(b.PublishDate);
            return dateA - dateB;
          });

          this.books = this.books.slice(0, 10);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  data() {
    return {
      books: [],
       headers: [
        { text: "Id", value: "ID", align: "center" },
        { text: "Title", value: "Title", align: "center" },
        { text: "Description", value: "Description", align: "center" },
        { text: "Page Count", value: "PageCount" },
        { text: "Publish Date", value: "PublishDate" },
      ],
    };
  },
  mounted() {
    this.getBooks();
  },
};
</script>

<style scoped></style>
